/* eslint-disable import/prefer-default-export */
import { createAction } from 'redux-actions';
import * as types from '../constants/actionTypes/customFonts';

export const updateCustomFonts = createAction(types.UPDATE_CUSTOM_FONTS);
export const setLoadedStatus = createAction(types.SET_LOADED_STATUS);
export const setInfoLoadedStatus = createAction(types.SET_INFO_LOADED_STATUS);
